import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';

import {
  IAboutMeResponse,
  IUserGeoDataResponse,
  IUserTemporaryTokenResponse,
} from '../types/user.types';

export const userService = {
  aboutMe: (): IResponse<IAboutMeResponse> => axiosInstance('api/users/me'),
  getTemporaryToken: (): IResponse<IUserTemporaryTokenResponse> =>
    axiosInstance.get('api/users/temporary-token'),
  getGeoData: (): IResponse<IUserGeoDataResponse> =>
    axiosInstance.get('api/users/geo-data'),
};
